export enum AddonFormType {
  Single = 'single',
  Group = 'group',
}
